export default __webpack_public_path__ + "static/media/expl-nn_13_DE.e8ea6e20.png";